import {get} from 'lodash';

export default (state = {}, {customerId, data}: any) => {
  return {
    ...state,
    planDetails: {
      ...get(state, 'planDetails', {}),
      [customerId]: data,
    },
  };
};
